/**
 * The plain words a Settings page draws for a stored member (decision 0472;
 * batch LBL, T1620), kept beside the maps that point at them in
 * `plainLabels.ts` and spread into the one lookup in `strings.ts`. 🔨 This
 * file imports nothing, because the lookup imports it.
 */
export const PLAIN_LABEL_STRINGS = {
  // Screening Tuning and the Lead Blocklist: the channel a policy scores.
  'plain.channel.websiteLead': 'Website leads',
  'plain.channel.inboundMail': 'Incoming mail',
  // The warning signs a channel scores, by the key the engine registers them under.
  'plain.signal.freemailSender': 'Free-mail sender',
  'plain.signal.roleAddress': 'Role address',
  'plain.signal.domainMismatchesCo': 'Email domain differs from the company website',
  'plain.signal.disposableDomain': 'Disposable-mail domain',
  'plain.signal.linkHeavy': 'Three or more links',
  'plain.signal.noBusinessText': 'Fewer than five words',
  'plain.signal.probePayload': 'Text shaped like an injection probe',
  'plain.signal.hasPhone': 'Gives a phone number',
  'plain.signal.honeypotTripped': 'Hidden form field filled',
  'plain.signal.fastFill': 'Form filled too fast',
  'plain.signal.mxLookupFailed': 'Email domain does not seem to take mail',
  'plain.signal.captchaFailed': 'CAPTCHA failed',
  'plain.signal.captchaUnconfigured': 'No CAPTCHA set up',
  'plain.signal.mentionsPartNumber': 'Names one of our part numbers',
  'plain.signal.displayNameMatchesInternalPerson': 'Name matches somebody who works here',
  'plain.signal.lookalikeDomain': 'Look-alike domain',
  'plain.signal.replyToDiffersFromFrom': 'Reply goes to a different domain',
  'plain.signal.linkTextMismatchesTarget': 'Link shows one address and goes to another',
  'plain.signal.firstTimeSenderAsksPaymentDetails': 'New sender asks about payment details',
  // The groups whose signals share one cap.
  'plain.signalGroup.noCorporateDomain': 'No company email domain',
  'plain.signalGroup.identitySpoofing': 'Forged sender identity',
  // The Lead Blocklist's match types.
  'plain.matchType.emailAddress': 'Email address',
  'plain.matchType.emailDomain': 'Email domain',
  'plain.matchType.ipOrCidr': 'IP address or range',
  // Custom Fields: the record types a field attaches to, and the kinds of answer.
  'plain.recordType.companyRecord': 'Company',
  'plain.recordType.personRecord': 'Person',
  'plain.recordType.locationRecord': 'Location',
  'plain.recordType.siteRecord': 'Site',
  'plain.fieldKind.text': 'Text',
  'plain.fieldKind.number': 'Number',
  'plain.fieldKind.enumerated': 'List of choices',
  'plain.fieldKind.date': 'Date',
  'plain.fieldKind.yesNo': 'Yes or no',
  'plain.fieldKind.measured': 'Measured',
  // Earning Code Map: what a mapped source is.
  'plain.earningSource.timeEntryType': 'Time entry type',
  'plain.earningSource.ptoPlanKind': 'Leave plan kind',
  'plain.earningSource.ptoPayoutPlanKind': 'Leave payout plan kind',
  'plain.earningSource.expenseKind': 'Expense kind',
  // Sales Goals: the figure a goal measures.
  'plain.goalMetric.bookedValue': 'Booked value',
  'plain.goalMetric.invoicedRevenue': 'Invoiced revenue',
  'plain.goalMetric.margin': 'Margin',
  'plain.goalMetric.dealsWon': 'Deals won',
  'plain.goalMetric.newAccounts': 'New accounts',
  'plain.goalMetric.loggedActivity': 'Logged activity',
  // Labor and Skill Levels: how the priority and after-hours premiums combine.
  'plain.composition.highestSingle': 'Use the highest premium only',
  'plain.composition.multiply': 'Multiply the premiums together',
  'plain.composition.additive': 'Add the premiums together',
} as const;
